(function () {
  'use strict';
  const Cls=window.AAHeadquartersClients;
  if(!Cls?.prototype||Cls.prototype.__aaLocationsFeature)return;
  const p=Cls.prototype, table='aa_client_locations';
  const esc=(ctx,value)=>ctx.escapeHtml(String(value??''));
  const store=ctx=>ctx.__aaLocationsCache||(ctx.__aaLocationsCache=new Map());
  function list(ctx,id,editable) {
    const state=store(ctx).get(String(id));
    if(!state||state.loading)return '<p>Loading additional locations...</p>';
    if(state.error)return '<p role="alert">Locations could not load: '+esc(ctx,state.error)+'</p>';
    if(!state.rows.length)return '<p>No additional locations yet.</p>';
    return state.rows.map(row=>[
      '<div class="aa-location-record" style="border-bottom:1px solid var(--aa-border,#ccc);padding:12px 0">',
      '<strong>',esc(ctx,row.location_name),'</strong>',
      '<div style="white-space:pre-line">',esc(ctx,row.address),'</div>',
      row.phone?'<small>'+esc(ctx,row.phone)+'</small>':'',
      '<small style="display:block">Additional location · Not used on contracts</small>',
      editable?'<div style="display:flex;gap:8px;margin-top:6px">'+
        '<button type="button" class="aa-button aa-button--secondary" data-aa-location-edit="'+esc(ctx,row.id)+'">Edit</button>'+
        '<button type="button" class="aa-button aa-button--secondary" data-aa-location-remove="'+esc(ctx,row.id)+'">Remove</button></div>':'',
      '</div>'
    ].join('')).join('');
  }
  const summary=p.renderClientSummary;
  if(typeof summary==='function')p.renderClientSummary=function(client){
    // Use the ordinary Business Address label on Overview. Contract usage
    // is already explained in Edit Client Info.
    const html=summary.call(this,client);
    const state=store(this).get(String(client.id));
    const hasExtra=Array.isArray(state?.rows)&&state.rows.length>0;
    return html.replace('</section>',
      '<div data-aa-location-summary="'+esc(this,client.id)+'" '+(hasExtra?'':'hidden')+' style="margin-top:16px">'+
      '<strong>Additional Store Locations</strong>'+
      '<div data-aa-location-display>'+list(this,client.id,false)+'</div>'+
      '</div></section>');
  };
  const editClient=p.renderEditClient;
  if(typeof editClient==='function')p.renderEditClient=function(client){
    // Preserve the complete existing client edit form and its Save/Cancel actions.
    // A second .aa-client-edit-panel would become a second fixed-position drawer.
    let html=editClient.call(this,client)
      .replace('Business Address\n','Primary Address (used for contracts)\n')
      .replace('<p class="aa-card__label">Edit Client Info</p>',
        '<div class="aa-client-editor-titlebar"><p class="aa-card__label">Edit Client Info</p>'+
        '<button type="button" class="aa-client-editor-close" data-aa-cancel-client-edit aria-label="Close Client Info">×</button></div>');
    const locationMarkup=[
      '<div class="aa-client-locations" data-aa-extra-locations="',esc(this,client.id),'">',
      '<div class="aa-client-locations__heading"><div><h3>Store Locations</h3>',
      '<p>The primary address above is used for contracts. Add any other store addresses here.</p></div>',
      '<button type="button" class="aa-button aa-button--secondary" data-aa-location-add>+ Add Location</button></div>',
      '<div class="aa-client-locations__list" data-aa-location-display>',list(this,client.id,true),'</div>',
      '<div data-aa-location-editor class="aa-client-locations__editor" hidden>',
      '<strong data-aa-location-editor-heading>Add Location</strong>',
      '<div class="aa-client-locations__fields">',
      '<label>Location Name<input type="text" maxlength="120" placeholder="e.g. Appleton" data-aa-location-name></label>',
      '<label>Phone (optional)<input type="tel" maxlength="60" placeholder="Store phone" data-aa-location-phone></label>',
      '<label class="aa-client-locations__address">Store Address',
      '<textarea rows="3" maxlength="600" placeholder="Street address, suite, city, state, ZIP" data-aa-location-address></textarea></label>',
      '</div><div class="aa-client-locations__actions">',
      '<button type="button" class="aa-button aa-button--primary" data-aa-location-save>Save Location</button>',
      '<button type="button" class="aa-button aa-button--secondary" data-aa-location-cancel>Cancel</button>',
      '</div><small>Location saves separately. It will not change the primary contract address.</small></div>',
      '<p data-aa-location-message class="aa-client-locations__message" role="status" aria-live="polite"></p>',
      '</div>'
    ].join('');
    const marker='<div class="aa-client-edit__group-heading">Internal Administration';
    if(!html.includes(marker)){
      console.warn('Client editor markup changed. Additional locations were not inserted.');
      return html;
    }
    return html.replace(marker,locationMarkup+marker);
  };
  p.__aaRefreshLocationMarkup=function(id){
    const selector='[data-aa-location-summary="'+id+'"] [data-aa-location-display]';
    const summaryEl=this.root.querySelector(selector);
    const summaryWrap=this.root.querySelector('[data-aa-location-summary="'+id+'"]');
    if(summaryWrap) {
      const activeRows=store(this).get(String(id))?.rows || [];
      summaryWrap.hidden=!activeRows.length;
    }
    if(summaryEl)summaryEl.innerHTML=list(this,id,false);
    const panel=this.root.querySelector('[data-aa-extra-locations="'+id+'"] [data-aa-location-display]');
    if(panel)panel.innerHTML=list(this,id,true);
  };
  p.__aaLoadLocations=async function(clientId,force=false){
    const id=String(clientId||'');
    if(!id)return;
    const cache=store(this);
    const current=cache.get(id);
    if(current&&!force){
      if(current.loading)return current.promise;
      if(!current.error)return;
    }
    const snap={loading:true,error:null,rows:current?.rows||[]};
    cache.set(id,snap);
    const job=(async()=>{
      try{
        const db=window.AASupabaseClient?.getClient?.();
        if(!db)throw Error('Connection unavailable.');
        const {data,error}=await db.from(table).select('id,client_id,location_name,address,phone,created_at')
          .eq('client_id',id).order('created_at',{ascending:true});
        if(error)throw error;
        if(cache.get(id)!==snap)return;
        cache.set(id,{loading:false,error:null,rows:Array.isArray(data)?data:[]});
      }catch(e){
        if(cache.get(id)!==snap)return;
        cache.set(id,{loading:false,error:e?.message||'Unknown error',rows:current?.rows||[]});
      }
      this.__aaRefreshLocationMarkup(id);
    })();
    snap.promise=job;
    this.__aaRefreshLocationMarkup(id);
    return job;
  };
  const render=p.render;
  if(typeof render==='function')p.render=function(...args){
    const result=render.apply(this,args);
    if(this.activeClientId && (this.activeClientTab==='overview' || String(this.editingClientId)===String(this.activeClientId))) void this.__aaLoadLocations(this.activeClientId);
    return result;
  };
  const bind=p.bindClientActions;
  if(typeof bind==='function')p.bindClientActions=function(){
    bind.call(this);
    if(this.__aaLocationEventsBound)return;
    this.__aaLocationEventsBound=true;
    this.root.addEventListener('click',async event=>{
      const control=event.target.closest?.('[data-aa-location-add],[data-aa-location-edit],[data-aa-location-remove],[data-aa-location-save],[data-aa-location-cancel]');
      if(!control)return;
      event.preventDefault();
      const panel=control.closest('[data-aa-extra-locations]');
      if(!panel)return;
      const id=panel.getAttribute('data-aa-extra-locations');
      if(id!==String(this.activeClientId)||id!==String(this.editingClientId))return;
      const editor=panel.querySelector('[data-aa-location-editor]');
      const name=panel.querySelector('[data-aa-location-name]');
      const address=panel.querySelector('[data-aa-location-address]');
      const phone=panel.querySelector('[data-aa-location-phone]');
      const message=panel.querySelector('[data-aa-location-message]');
      const say=(text,error=false)=>{if(message){message.textContent=text;message.dataset.statusType=error?'error':'success';}};
      const rows=store(this).get(id)?.rows||[];
      if(control.hasAttribute('data-aa-location-add')){
        editor.dataset.id='';name.value='';address.value='';phone.value='';
        editor.querySelector('[data-aa-location-editor-heading]').textContent='Add Location';
        editor.hidden=false;name.focus();return;
      }
      if(control.hasAttribute('data-aa-location-cancel')){editor.hidden=true;return;}
      if(control.hasAttribute('data-aa-location-edit')){
        const row=rows.find(r=>String(r.id)===control.getAttribute('data-aa-location-edit'));
        if(!row){say('Location no longer available. Reopen client.',true);return;}
        editor.dataset.id=row.id;
        name.value=row.location_name||'';address.value=row.address||'';phone.value=row.phone||'';
        editor.querySelector('[data-aa-location-editor-heading]').textContent='Edit Additional Location';
        editor.hidden=false;name.focus();return;
      }
      const db=window.AASupabaseClient?.getClient?.();
      if(!db){say('Database connection unavailable.',true);return;}
      if(control.hasAttribute('data-aa-location-remove')){
        const row=rows.find(r=>String(r.id)===control.getAttribute('data-aa-location-remove'));
        if(!row)return;
        if(!window.confirm('Remove '+row.location_name+'? The primary contract address will remain unchanged.'))return;
        control.disabled=true;
        try{
          const {data,error}=await db.from(table).delete().eq('client_id',id).eq('id',row.id).select('id');
          if(error)throw error;
          if(!data?.length)throw Error('Removal was not confirmed.');
          await this.__aaLoadLocations(id,true);
          say('Location removed. Primary address unchanged.');
        }catch(e){say(e?.message||'Could not remove location.',true);}
        finally{if(control.isConnected)control.disabled=false;}
        return;
      }
      if(control.hasAttribute('data-aa-location-save')){
        const locName=name.value.trim(),locAddress=address.value.trim(),locPhone=phone.value.trim();
        if(!locName||!locAddress){say('Location name and address are required.',true);return;}
        const locationId=editor.dataset.id||'';
        control.disabled=true;control.textContent='Saving...';
        try{
          const row={location_name:locName,address:locAddress,phone:locPhone||null,updated_at:new Date().toISOString()};
          const request=locationId
            ?db.from(table).update(row).eq('client_id',id).eq('id',locationId).select('id').single()
            :db.from(table).insert({...row,client_id:id}).select('id').single();
          const {data,error}=await request;
          if(error)throw error;
          if(!data?.id)throw Error('Save was not confirmed.');
          editor.hidden=true;editor.dataset.id='';
          await this.__aaLoadLocations(id,true);
          say('Additional location saved. Contract address unchanged.');
        }catch(e){say(e?.message||'Could not save location.',true);}
        finally{if(control.isConnected){control.disabled=false;control.textContent='Save Location';}}
      }
    });
  };
  p.__aaLocationsFeature=true;
})();